const FormatCurrencyComponent = ({ amount, currency }) => {
  if (!amount || !currency) {
    return '';
  }

  return <span>{Intl.NumberFormat('nl-nl', { style: 'currency', currency }).format(amount / 100)}</span>;
};

export default FormatCurrencyComponent;
